<h2>Select Current Station</h2>
<mat-dialog-content class="fullWidthWrapper">
    <app-select-station (stationChanged)="stationChanged()"></app-select-station>
</mat-dialog-content>